import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { cloneElement, type ReactElement } from 'react';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function applySizeClass<T extends keyof typeof iconSizeClasses>(
  icon: ReactElement,
  size: T
) {
  const existingClassName = (icon.props as { className?: string }).className;
  return cloneElement(icon, {
    className: cn(iconSizeClasses[size], existingClassName),
  } as Record<string, unknown>);
}

export const iconSizeClasses = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
  xl: 'h-14 w-14',
  icon: 'h-6 w-6',
} as const;
